import { Link as ChakraLink, IconButton, Tooltip } from '@chakra-ui/react';
import { MdDialpad } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';

import { ServiceCardDetail } from '../ServiceCardLayout';

const ManageNumbers = ({
    cardStatus,
    isTrialExpired,
    darkMode,
    numbersPath,
}) => {
    const { pathname } = useLocation();
    // (3158) Cards in a section share one height now, so there is no need
    // to reserve this row's space when it's hidden.
    if (cardStatus?.statusLabel !== 'Healthy' || isTrialExpired) return null;

    return (
        <ServiceCardDetail label="Manage Numbers:">
            <Tooltip
                label="Associate and Manage Mobile Operator Accounts and Numbers"
                hasArrow
                placement="bottom">
                <ChakraLink
                    as={Link}
                    to={`/${numbersPath}`}
                    state={{
                        from: pathname,
                    }}>
                    <IconButton
                        icon={
                            <MdDialpad
                                icon="Settings"
                                color={darkMode ? 'white' : 'black'}
                            />
                        }
                        size="xs"
                        bg="transparent"
                        _hover={{ bg: 'transparent' }}
                        _active={{ bg: 'transparent' }}
                        _focus={{ bg: 'transparent' }}
                        onClick={() => {}}
                    />
                </ChakraLink>
            </Tooltip>
        </ServiceCardDetail>
    );
};

export default ManageNumbers;
